import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { getVenuesData } from "../../data/venues.js";
import "./venuePage.css";
import { GeoAltFill } from "react-bootstrap-icons";

const VenuePage = () => {
  const venuesData = getVenuesData();
  const { heroimg, heading, subtitle, description, mainVenue, venues } = venuesData;

  return (
    <section className="venue-page">
      <div
        className="venue-hero"
        style={{
          backgroundImage: `linear-gradient(180deg, #000000A3, #000000A3), url(${heroimg.image})`,
        }}
      >
        <Container fluid className="col-md-11 mx-auto">
          <Row>
            <Col lg={8} md={9}>
              <h1 className="venue-hero__title mb-4">{heading}</h1>
              <p className="venue-hero__subtitle mb-3">{subtitle}</p>
              <p className="venue-hero__description mb-4">{description}</p>
            </Col>
          </Row>
        </Container>
      </div>

      <Container fluid className="col-md-11 mx-auto venue-content">
        <Card className="venue-card venue-card--main border-0 shadow-sm">
          <div className="venue-card__image-wrapper">
            <Card.Img src={mainVenue.image} className="venue-card__image" />
          </div>
          <Card.Body className="venue-card__body">
            <div className="d-flex justify-content-between">
              <Card.Title className="fw-semibold">
                {mainVenue.name}
              </Card.Title>
              <div className="venue-card__location">
                <span className="fs-5 location_icon"><GeoAltFill /></span>
                <span>{mainVenue.locationLabel}</span>
              </div>
            </div>
          </Card.Body>
        </Card>

        <Row className="g-4 mt-4">
          {venues.map((venue) => (
            <Col lg={4} md={6} sm={6} xs={12} key={venue.id}>
              <Card className="venue-card border-0 shadow-sm h-100">
                <div className="venue-card__image-wrapper">
                  <Card.Img
                    src={venue.image}
                    className="venue-card__image"
                    alt={venue.name}
                  />
                </div>
                <Card.Body className="venue-card__body">
                  <Card.Title className="venue-card__title">
                    {venue.name}
                  </Card.Title>
                  <div className="venue-card__location">
                    <span className="fs-5 location_icon"><GeoAltFill /></span>
                    <span>{venue.locationLabel}</span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default VenuePage;

